import { render, staticRenderFns } from "./groupFitnessDashboardCourses.vue?vue&type=template&id=3e549179&scoped=true"
import script from "./groupFitnessDashboardCourses.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardCourses.vue?vue&type=script&lang=js"
import style0 from "./groupFitnessDashboardCourses.vue?vue&type=style&index=0&id=3e549179&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e549179",
  null
  
)

export default component.exports